var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntermediate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Intermediate_qualification",
    "data-name": "Intermediate qualification",
    transform: "translate(-752 -502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 30,
    height: 30,
    transform: "translate(752 502)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "guarantee",
    transform: "translate(756 507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M289.328,335.019a1.171,1.171,0,0,1-.942-.461,1.151,1.151,0,0,1-.226,0v4.36l.937-.7a.39.39,0,0,1,.469,0l.937.7v-4.36a1.159,1.159,0,0,1-.234,0A1.171,1.171,0,0,1,289.328,335.019Zm0,0",
    transform: "translate(-274.097 -318.232)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M0,352.39a1.171,1.171,0,0,0,1.171,1.171H13.283V352H0Zm0,0",
    transform: "translate(0 -334.822)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M275.809,249.573a.39.39,0,0,1-.222-.536.406.406,0,0,0-.539-.542.39.39,0,0,1-.536-.222.4.4,0,0,0-.763,0,.39.39,0,0,1-.536.222.406.406,0,0,0-.539.542.391.391,0,0,1-.222.535.406.406,0,0,0,0,.765.391.391,0,0,1,.222.536.406.406,0,0,0,.539.542.39.39,0,0,1,.536.222.4.4,0,0,0,.763,0,.39.39,0,0,1,.536-.222.406.406,0,0,0,.539-.542.39.39,0,0,1,.222-.536.406.406,0,0,0,0-.765Zm0,0",
    transform: "translate(-258.9 -235.901)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M64,1.171V16.4h10.16v-.434A1.173,1.173,0,0,1,73.837,15a1.192,1.192,0,0,1,0-1.882,1.191,1.191,0,0,1,1.327-1.331,1.189,1.189,0,0,1,1.88,0,1.19,1.19,0,0,1,1.327,1.331,1.192,1.192,0,0,1,0,1.882,1.171,1.171,0,0,1-.312.956v2.716a1.159,1.159,0,0,0,.384.072,1.171,1.171,0,0,0,1.171-1.171V1.171a1.946,1.946,0,0,1,.037-.362c.007-.037.018-.072.027-.108a1.981,1.981,0,0,1,.073-.234c.015-.039.032-.076.049-.113a1.955,1.955,0,0,1,.112-.207c.02-.033.039-.066.062-.1.011-.016.019-.034.031-.049H65.17A1.171,1.171,0,0,0,64,1.171Zm13.664,8.2H71.026V8.589h6.637Zm0-1.952H68.684V6.637h8.979ZM72.978,2.342H74.54v.781H72.978Zm-3.9,0H72.2v.781H69.074ZM67.9,4.294h7.808v.781H67.9ZM65.951,6.637H67.9v.781H65.951Zm0,1.952h4.294V9.37H65.951Zm0,1.952h7.808v.781H65.951Zm0,1.952h6.637v.781H65.951Zm0,0",
    transform: "translate(-60.876 0)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M401.171,0A1.171,1.171,0,0,0,400,1.171v.39h2.342v-.39A1.171,1.171,0,0,0,401.171,0Zm0,0",
    transform: "translate(-380.48)",
    fill: "#3f2765"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediate);
export default __webpack_public_path__ + "static/media/Intermediate.59cd1dfc862011e1beabb951f37bb4fa.svg";
export { ForwardRef as ReactComponent };